import {isRTL} from '../../Localization';
import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_COPYTOBUFFER';

const en = {
    copyToBuffer: 'Copy & Save to Buffer',
    pasteFromBuffer: 'Paste from Buffer',
    ok: 'Ok',
    cancel: 'Cancel',
    copy: 'Copy',
    paste: 'Paste',
    delete: 'Delete',
    id_already_exists_error:
        'No. X already exists as a buffer. If you click Copy, you will replace No. X with the new value.',
    value_already_exists_error: 'This content already exists in buffer No. Y.'
};

const he = {
    copyToBuffer: 'העתקה ושמירה בתא',
    pasteFromBuffer: 'הדבקה מתא',
    ok: 'אישור',
    cancel: 'ביטול',
    copy: 'עותק',
    paste: 'לְהַדבִּיק',
    delete: 'לִמְחוֹק',
    value_already_exists_error: ' Y תוכן זה כבר קיים במאגר מס.',
    id_already_exists_error: `לא. X כבר קיים כמאגר. אם תלחץ על העתק, תחליף את מס' X בערך החדש.`
};

export const mapping = {
    1: 'copy_to_buffer_title',
    2: 'no_field',
    3: 'mandatory_field_error',
    4: 'copy_button',
    5: 'value_already_exists_error',
    6: 'id_already_exists_error',
    7: 'value_field',
    8: 'description_Field',
    9: 'buffer',
    10: 'value_field_in_list',
    11: 'clear_all',
    12: 'help_text_copy',
    13: 'cancel_button',
    14: 'paste_from_buffer_title',
    15: 'delete',
    16: 'search_by_num_or_description',
    17: 'dont_find_search',
    18: 'paste_button',
    19: 'help',
    20: 'help_text_paste',
    21: 'text_for_empty_buffer',
    22: 'delete_msg_text',
    23: 'delete_all_items_msg'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

const fallbacks = {
    en,
    he
};
// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

export const localText = isRTL() ? he : en;
// export entity texts
// usage: import texts from './texts'
export default texts[entity];
